export { CasosDoSetor } from './CasosDoSetor'
